import { user } from '@/services'

const mixin = {
  data: () => ({
    declarationModalVisibility: false
  }),

  computed: {
    userFirstName () {
      return user.getFirstname()
    },

    declarationMessage () {
      return `
        <p>Eu <strong>${this.userFirstName}</strong>, ao clicar em "OK" declaro que todas as informações são verdadeiras!</p> <br />
        <p>Me <strong>${this.userFirstName}</strong>, by clicking in "OK" declare that all the information is true!</p>
      `
    }
  },

  methods: {
    // @vuese Método para fechar modal de declaração
    closeDeclarationModal () {
      this.declarationModalVisibility = false
    },

    // @vuese Método para fechar modal de declaração
    openDeclarationModal () {
      this.declarationModalVisibility = true
    }
  }
}

export default mixin
